import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { db } from '../firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';

const CustomizeProjectForm = () => {
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, 'custom_projects'), {
        name,
        contact,
        message,
        createdAt: Timestamp.now()
      });
      setSuccessMsg("Inquiry submitted successfully!");
      setName('');
      setContact('');
      setMessage('');
    } catch (error) {
      console.error("Error storing data: ", error);
      setSuccessMsg("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div 
      className="py-24 px-6 relative bg-cover bg-center"
      style={{
        backgroundImage: `url('https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Decorative/5.jpeg')`
      }}
    >
      <div className="absolute inset-0 bg-black/60"></div>
      
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center relative">
        <motion.div
          className="space-y-6"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl text-white font-serif">Customise Your Project</h2>
          <div className="w-24 h-1.5 bg-amber-500 rounded-full" />
          <p className="text-gray-200 text-lg mt-4 leading-relaxed">
            Let's create something beautiful together.<br/> Whether you’re looking for curated artworks or wallpapers for your home or corporate space, we’ve got you covered.<br/>Have something specific in mind? Share your vision with us, and we’ll transform it into a stunning reality, designed  just for you.
          </p>
        </motion.div>

        <motion.form
          onSubmit={handleSubmit}
          className="space-y-6 bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 shadow-2xl"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-200 mb-2">Full Name</label>
            <input
              id="name"
              type="text"
              placeholder="e.g., John Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full px-5 py-4 bg-black/20 text-white border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 placeholder-gray-400"
            />
          </div>
          <div>
            <label htmlFor="contact" className="block text-sm font-medium text-gray-200 mb-2">Contact Number</label>
            <input
              id="contact"
              type="tel"
              placeholder="e.g., +1 234 567 890"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
              className="w-full px-5 py-4 bg-black/20 text-white border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 placeholder-gray-400"
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-200 mb-2">Your Vision</label>
            <textarea
              id="message"
              rows="4"
              placeholder="Tell us about your project or inquiry..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              className="w-full px-5 py-4 bg-black/20 text-white border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 placeholder-gray-400"
            ></textarea>
          </div>

          {successMsg && (
            <p className="text-green-300 text-sm">{successMsg}</p>
          )}

          <motion.button
            type="submit"
            className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-4 rounded-lg transition-all duration-300 shadow-lg"
            whileHover={{ scale: 1.02, boxShadow: '0 0 20px rgba(245, 158, 11, 0.6)' }}
            whileTap={{ scale: 0.98 }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Submit Inquiry"}
          </motion.button>
        </motion.form>
      </div>
    </div>
  );
};

export default CustomizeProjectForm;